import Date from '../date/Date.js';


export default class ChildHandicap {
    constructor() {
        this.start = null;
        this.end = null;
        this.confirmedAt = null;
        this.requestedAt = null;
        this.presentedAt = null;
        this.handicapType = null;
        this.deleted = false;
        this.id = null;
    }
    static fromData(data) {
        if (!data) {
            return;
        }

        const childHandicap = new ChildHandicap();
        childHandicap.start = data.start !== null ? Date.fromIso8601(data.start) : null;
        childHandicap.end = data.end !== null ? Date.fromIso8601(data.end) : null;
        childHandicap.confirmedAt = data.confirmedAt !== null ? Date.fromIso8601(data.confirmedAt) : null;
        childHandicap.requestedAt = data.requestedAt !== null ? Date.fromIso8601(data.requestedAt) : null;
        childHandicap.presentedAt = data.presentedAt !== null ? Date.fromIso8601(data.presentedAt) : null;
        childHandicap.handicapType = data.handicapType;
        childHandicap.deleted = false;
        childHandicap.id = data.id;

        return childHandicap;
    }
    serialize() {
        return {
            start: this.start ? this.start.toIso8601() : null,
            end: this.end ? this.end.toIso8601() : null,
            confirmedAt: this.confirmedAt ? this.confirmedAt.toIso8601() : null,
            requestedAt: this.requestedAt ? this.requestedAt.toIso8601() : null,
            presentedAt: this.presentedAt ? this.presentedAt.toIso8601() : null,
            handicapType: this.handicapType,
            deleted: this.deleted,
            id: this.id,
        }
    }
}
